<script setup>
import { ref, onMounted } from "vue";
//import Conf from '@/Components/MainGlobal.vue';
import SeoMeta from '@/Components/SeoMeta.vue';
import CardBoxModal from "@/Components/CardBoxModal.vue";
import BreezeInput from '@/Components/Input.vue';
import BreezeLabel from '@/Components/Label.vue';
import BreezeCheckbox from '@/Components/Checkbox.vue';
import { Head, Link, useForm } from '@inertiajs/inertia-vue3';
//import BreezeApplicationLogo from '@/Components/ApplicationLogo.vue';
import BreezeApplicationLogoFull from '@/Components/ApplicationLogoFull.vue';
import BreezeDropdown from '@/Components/Dropdown.vue';
import BreezeDropdownLink from '@/Components/DropdownLink.vue';

import BaseButton from "@/Components/BaseButton.vue";
import Footer from '@/Components/Footer.vue';
import { Inertia } from '@inertiajs/inertia';
import BreezeButton from '@/Components/Button.vue';
import BreezeGuestLayout from '@/Layouts/Guest.vue';
import { Splide, SplideSlide, SplideTrack } from '@splidejs/vue-splide';
import { defineComponent } from 'vue';
import { GoogleMap, Marker } from "vue3-google-map";
import helpers from '@/Common/helpers';
import '@splidejs/vue-splide/css';
import BaseIcon from "@/Components/BaseIcon.vue";
import {
    mdiMagnify,
    mdiChevronDown,
    mdiAccountOutline,
    mdiCartOutline,
    mdiHeartOutline,
    mdiMenu,
    mdiCloseThick,
    mdiHeadset,
    mdiFacebook,
    mdiInstagram,
    mdiTwitter,
    mdiWhatsapp,
    mdiYoutube,
    mdiTruckFastOutline,
    mdiReload,
    mdiShieldLockOutline,
    mdiTrophyOutline,
    mdiArrowRight,
    mdiShoppingOutline,
    mdiStar,
    mdiArrowExpandAll,
    mdiRepeat,
    mdiChevronRight,
    mdiMinus,
    mdiPlus,
    mdiFlagVariant,
    mdiMoped,
    mdiPercent,
    mdiPhone,
    mdiEmail,
    mdiMapMarker,
    mdiHandshakeOutline,
    mdiAccountGroupOutline,
    mdiShieldStarOutline,
    mdiTruckDeliveryOutline,
    mdiTrashCan,
    mdiStarOutline,

} from "@mdi/js";

const props = defineProps({
    canLogin: Boolean,
    canRegister: Boolean,
    laravelVersion: String,
    phpVersion: String,
    appVersion: String,
    contentWelcome: String,
    accessStudents: Boolean,
    accessParents: Boolean,
    object: Object,
    tallas: Array,
    categoryChild: Object,
    categoryParent: Object,
    //connstantes: Array

})



// LRR
//const confGlobal = props.connstantes
/*const confGlobal = ref([])
onMounted(() => {
  let url = '/constante/global';
  axios.get(url).then(function (response) {
      var respuesta = response.data;
      confGlobal.value = respuesta.constantes;
      //console.log(me.constante);
    }).catch(function (error) {
        console.log(error);
  });
});
*/
//console.log( props.connstantes )

const form = useForm({
    email: '',
    nombre: '',
    phone: '',
    comment: '',
    recibirinfo: false
});
const isModalActive = ref(false);

const stocklabel = ref(false)

onMounted(() => {
    getCart()
});

//const total_ttc = ref(0)
const carrito = ref([])
const getCart = () => {
    let cart = []
    //let cartStorage = localStorage.getItem('cart')
    let cartStorage = sessionStorage.getItem('cart')
    if (cartStorage && cartStorage.length > 0) {
        cart = JSON.parse(cartStorage)
        carrito.value = cart
    }
}


// Información de Slide, limite x 4

const slidePrincipal = ref(null)
slidePrincipal.value = [
    { 'id': '01', 'label': 'Vr Box 3D Glass', 'referencia_producto': 'Explora nuestra colección tecnológica', 'ruta_imagen': '/img/slide/slide-1.png' },
    { 'id': '02', 'label': 'Vr Box 3D Glass', 'referencia_producto': 'Explora nuestra colección tecnológica', 'ruta_imagen': '/img/slide/slide-2.png' },
    { 'id': '03', 'label': 'Vr Box 3D Glass', 'referencia_producto': 'Explora nuestra colección tecnológica', 'ruta_imagen': '/img/slide/slide-3.png' },
]

//produtos nuevos ORDER BY created_at LIMIT 8
const productosNuevos = ref(null)
productosNuevos.value = [
    { 'id': '28', 'label': 'Play Station 5 + Mando', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 5, 'stock': '4', 'ruta_imagen': '/img/productos/01.jpg' },
    { 'id': '27', 'label': 'Play Station 5 + Mando', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 0, 'rating': 1, 'stock': '0', 'ruta_imagen': '/img/productos/02.jpg' },
    { 'id': '26', 'label': 'Play Station 5 + Mando', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 0, 'stock': '2', 'ruta_imagen': '/img/productos/03.jpg' },
    { 'id': '25', 'label': 'Play Station 5 + Mando', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 5, 'stock': '4', 'ruta_imagen': '/img/productos/04.jpg' },
    { 'id': '24', 'label': 'Play Station 5 + Mando', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 5, 'stock': '1', 'ruta_imagen': '/img/productos/05.jpg' },
    { 'id': '23', 'label': 'Play Station 5 + Mando', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 5, 'stock': '4', 'ruta_imagen': '/img/productos/06.jpg' },
    { 'id': '22', 'label': 'Play Station 5 + Mando', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 5, 'stock': '4', 'ruta_imagen': '/img/productos/07.jpg' },
    { 'id': '21', 'label': 'Play Station 5 + Mando', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 5, 'stock': '4', 'ruta_imagen': '/img/productos/08.jpg' }
]

const productosDestacados = ref(null)
productosDestacados.value = [
    { 'id': '31', 'label': 'Monitor Curvo Samsung 49″ WQLED LS49A950', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 5, 'ruta_imagen': '/img/productos/20.jpg' },
    { 'id': '32', 'label': 'Tablet Samsung Galaxy Tab S7 Fe 64gb', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 5, 'ruta_imagen': '/img/productos/21.jpg' },
    { 'id': '33', 'label': 'Asus ROG Strix RX5700 XT O8G 8GB', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 5, 'ruta_imagen': '/img/productos/22.jpg' },
    { 'id': '34', 'label': 'Impresora HP LaserJet 107W', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 5, 'ruta_imagen': '/img/productos/23.jpg' },
    { 'id': '35', 'label': 'Impresora Multifuncional Epson EcoTank L3110', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 5, 'ruta_imagen': '/img/productos/24.jpg' },
    { 'id': '36', 'label': 'Mochila Lenovo Thinkpad Professional G2', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 5, 'ruta_imagen': '/img/productos/25.jpg' }
]

const marcas = ref(null)
marcas.value = [
    { 'id': '101', 'ruta_imagen': '/img/marcas/01.png' },
    { 'id': '102', 'ruta_imagen': '/img/marcas/02.png' },
    { 'id': '103', 'ruta_imagen': '/img/marcas/03.png' },
    { 'id': '104', 'ruta_imagen': '/img/marcas/04.png' },
    { 'id': '105', 'ruta_imagen': '/img/marcas/05.png' },
    { 'id': '106', 'ruta_imagen': '/img/marcas/06.png' },
    { 'id': '107', 'ruta_imagen': '/img/marcas/07.png' },
    { 'id': '108', 'ruta_imagen': '/img/marcas/08.png' },
    { 'id': '109', 'ruta_imagen': '/img/marcas/09.png' },
    { 'id': '110', 'ruta_imagen': '/img/marcas/10.png' },
    { 'id': '111', 'ruta_imagen': '/img/marcas/11.png' },
    { 'id': '112', 'ruta_imagen': '/img/marcas/12.png' }
]


// Google maps
const YOUR_GOOGLE_MAPS_API_KEY = ref('AIzaSyCsT0Kr6WvAxXhz60S6i5BOguepFaeoUtg')
const center = ref({ lat: -11.992628, lng: -77.071254 })
const locations = ref([
    { lat: -11.992628, lng: -77.071254 }
])

</script>






<!-- <script>
import { Splide, SplideSlide } from '@splidejs/vue-splide';


export default defineComponent({
    name: 'ThumbnailsExample',

    components: {
        Splide,
        SplideSlide,
    },

    setup() {
        
        const slides = generateSlides();


        onMounted(() => {
            const thumbsSplide = thumbs.value?.splide;

            if (thumbsSplide) {
                main.value?.sync(thumbsSplide);
            }
        });

        return {
            slides,
            main,
            thumbs,
            mainOptions,
            thumbsOptions,
        }
    },
});

</script> -->



<template>
    <SeoMeta />
    <!-- Head con categorías -->
    <BreezeGuestLayout :categoryChild="categoryChild" :categoryParent="categoryParent">

        <!-- START AREA DE TITULO -->
        <!-- START AREA DE TITULO -->
        <!-- START AREA DE TITULO -->

        <section>
            <div class="w-full h-[250px ] relative">
                <div aria-hidden="true" class="px-4 sm:px-6 lg:px-8 py-10 lg:py-20 inset-0 absolute bg-[url('/img/empresa/informacion/header.jpg')] bg-no-repeat bg-center bg-cover">
                </div>
                <div class="px-4 sm:px-6 lg:px-8 py-10 lg:py-20 absolute inset-0 bg-black bg-opacity-50">
                </div>
                <div class="container mx-auto px-4 sm:px-6 lg:px-8 py-10 lg:py-20">
                    <div class="relative flex flex-col sm:flex-row lg:justify-between items-center">
                        <div>
                            <h1 class="text-2xl lg:text-3xl text-white">Realizar Pago</h1>
                        </div>
                        <div>
                            <p class="text-xs lg:text-sm text-white font-semibold">Inicio / <span class="text-xs lg:text-sm font-normal">Compra de Productos</span></p>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- END AREA DE TITULO -->
        <!-- END AREA DE TITULO -->
        <!-- END AREA DE TITULO -->

        <!-- START INFO EMPRESA -->
        <!-- START INFO EMPRESA -->
        <!-- START INFO EMPRESA -->

        <section>
            <div class="container mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-20">
                <div class="grid grid-cols-1 gap-4">
                    <div class="col-span-1">
                        <h1 class="text-2xl lg:text-3xl font-bold mb-4 ">Pedido Realizado</h1>
                    </div>

                    <div>
                        <div class="pb-4">
                            <p class="text-sm text-gray-800">A continuación puede visualizar un resumen de los productos seleccionados para adquirir</p>
                        </div>

                    </div>

                </div>
                <div class="grid grid-cols-1 xl:grid-cols-2 gap-8">
                    <div class="flex-1">
                        <h1 class="sm:text-2xl text-xl font-semibold mb-5">Resumen del Pedido</h1>
                        <div class="w-full p-5 lg:p-8 border border-gray-200 rounded-lg">
                            <div class="sub-total mb-6">
                                <div class=" flex justify-between mb-5">
                                    <p class="text-sm font-semibold uppercase">Productos</p>
                                    <p class="text-sm font-semibold uppercase">Total</p>
                                </div>
                            </div>
                            <hr class="my-4">
                            <div class="w-full mb-4" :set="total = 0">
                                <ul class="flex flex-col space-y-5 list-none lg:list-disc lg:ml-2 ml-0">
                                    <li v-for="(item, index) in carrito" :key="index" :set="(total += parseFloat(item.price) * parseInt(item.cant) )">
                                        <div class="flex justify-between items-center">
                                            <div>
                                                <h4 class="text-xs lg:text-sm"><span class="font-semibold">SKU: {{ item.ref }}</span> x {{ item.cant }}</h4>
                                                <p class="text-sm lg:text-base">{{ item.label }}</p>
                                            </div>
                                            <div class="min-w-36 w-36">
                                                <p class="w-full text-right text-sm lg:text-base font-medium">{{ helpers.currencySymbol(confGlobal.value.COMPANY_MULTICURRENCY_CODE) }} {{ item.price * item.cant }}</p>
                                            </div>

                                        </div>
                                    </li>
                                                                        
                                </ul>
                            </div>
                            <hr class="my-4">
                            <!-- <div class="w-full mt-4">
                                <div class=" flex justify-between mb-5">
                                    <p class="text-sm font-semibold ">Envio </p>
                                    <p class="text-base font-semibold">Gratis</p>
                                </div>
                            </div> -->
                            <!-- <div class="mt-4">
                                <div class=" flex justify-between mb-5">
                                    <p class="text-sm font-semibold ">Sub total</p>
                                    <p class="text-base font-semibold uppercase">S/ 11440.67</p>
                                </div>
                                <div class=" flex justify-between mb-5">
                                    <p class="text-sm font-semibold ">IGV</p>
                                    <p class="text-base font-semibold uppercase">S/ 2059.32</p>
                                </div>
                            </div> -->

                            <hr class="my-4">
                            <div class="mt-4">
                                <div class=" flex justify-between mb-5">
                                    <p class="text-2xl font-semibold ">Total</p>
                                    <p class="text-2xl font-semibold">{{ helpers.currencySymbol(confGlobal.value.COMPANY_MULTICURRENCY_CODE) }} {{ helpers.unensRound(total) }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="flex-1">
                        <h1 class="sm:text-2xl text-xl font-semibold mb-5">Métodos de Pago</h1>
                        <div class="w-full p-5 lg:p-8  border border-gray-200 rounded-lg">
                            <div>
                                <div class="pb-4">
                                    <p class="font-semibold text-xl pb-2">Via transferencia</p>
                                    <p class="text-sm">
                                        Titular de la cuenta: <span class="text-color font-semibold">{{ confGlobal.value.COMPANY_NAME }}</span>.
                                        Las cuentas disponibles son las siguientes:
                                    </p>
                                </div>
                                <hr class="my-4">
                                <div v-if="!helpers.isEmpty(confGlobal.value.ACCOUNT_NUMBER_BCP)" class="flex items-center space-x-4">
                                    <div class="w-24 lg:w-36">
                                        <img src="/img/venta/bcp.svg" class="h-8 object-contain">
                                    </div>
                                    <div class="text-sm text-gray-800">
                                        <div class="flex flex-col sm:flex-row">
                                            <span class="font-semibold mr-2">Cuenta:</span> {{ confGlobal.value.ACCOUNT_NUMBER_BCP }}
                                        </div>
                                        <div v-if="!helpers.isEmpty(confGlobal.value.ACCOUNT_NUMBER_CCI_BCP)" class="flex flex-col sm:flex-row">
                                            <span class="font-semibold mr-2">CCI:</span> {{ confGlobal.value.ACCOUNT_NUMBER_CCI_BCP }}
                                        </div>
                                    </div>
                                </div>
                                <hr class="my-4">
                                <div v-if="!helpers.isEmpty(confGlobal.value.ACCOUNT_NUMBER_INTERBANK)" class="flex items-center space-x-4">
                                    <div class="w-24 lg:w-36">
                                        <img src="/img/venta/interbank.svg" class="h-8 object-contain">
                                    </div>
                                    <div class="text-sm text-gray-800">
                                        <div class="flex flex-col sm:flex-row">
                                            <span class="font-semibold mr-2">Cuenta:</span> {{ confGlobal.value.ACCOUNT_NUMBER_INTERBANK }}
                                        </div>
                                        <div v-if="!helpers.isEmpty(confGlobal.value.ACCOUNT_NUMBER_CCI_INTERBANK)" class="flex flex-col sm:flex-row">
                                            <span class="font-semibold mr-2">CCI:</span> {{ confGlobal.value.ACCOUNT_NUMBER_CCI_INTERBANK }}
                                        </div>
                                    </div>
                                </div>
                                <hr class="my-4">
                                <div v-if="!helpers.isEmpty(confGlobal.value.ACCOUNT_NUMBER_BBVA)" class="flex items-center space-x-4">
                                    <div class="w-24 lg:w-36">
                                        <img src="/img/venta/bbva.svg" class="h-8 object-contain">
                                    </div>
                                    <div class="text-sm text-gray-800">
                                        <div class="flex flex-col sm:flex-row">
                                            <span class="font-semibold mr-2">Cuenta:</span> {{ confGlobal.value.ACCOUNT_NUMBER_BBVA }}
                                        </div>
                                        <div v-if="!helpers.isEmpty(confGlobal.value.ACCOUNT_NUMBER_CCI_BBVA)" class="flex flex-col sm:flex-row">
                                            <span class="font-semibold mr-2">CCI:</span> {{ confGlobal.value.ACCOUNT_NUMBER_CCI_BBVA }}
                                        </div>
                                    </div>
                                </div>
                                <hr class="my-4">
                                <div v-if="!helpers.isEmpty(confGlobal.value.ACCOUNT_NUMBER_PHONE_YAPE)" class="flex items-center space-x-4">
                                    <div class="w-24 lg:w-36">
                                        <img src="/img/venta/yape.svg" class="h-8 object-contain">
                                    </div>
                                    <div class="text-sm text-gray-800">
                                        <div class="flex flex-col sm:flex-row">
                                            <span class="font-semibold mr-2">Celular:</span> {{ confGlobal.value.ACCOUNT_NUMBER_PHONE_YAPE }}
                                        </div>
                                        <!-- <div class="flex flex-col sm:flex-row">
                                            <span class="font-semibold mr-2">QR:</span>
                                        </div> -->
                                    </div>
                                </div>
                                <hr class="my-4">
                            </div>
                            <!-- <div class="pt-4 space-y-4">
                                <p class="text-base text-gray-800">Proceda a coordinar la compra via Whatsapp con uno de nuestros asesores</p>
                                <div class="w-full flex justify-center">
                                    <BaseButton :icon="mdiStarOutline" small label="Coordinar compra via Whatsapp" class="btn btn-color px-8" />
                                </div>

                            </div> -->
                            <a :href="'https://wa.me/51'+confGlobal.value.COMPANY_PHONE_MOBILE" target="_blank">
                                <div class="flex justify-between rounded-lg min-h-[95px]">
                                    <div class="bg-[#25D366] flex items-center justify-center p-4 rounded-l-lg">
                                        <BaseIcon :path="mdiWhatsapp" :size="60" class="text-white" w="w-14" h="h-14" />
                                    </div>
                                    
                                    <button class="text-white text-left p-4 w-full bg-sky-500 hover:bg-sky-700 focus:ring-4 focus:!ring-sky-300 focus:!outline-none border !border-sky-500 transition ease-in-out duration-150 rounded-r-lg">
                                        <p class="text-xs font-semibold">Atención personalizada</p>
                                        <p class="text-base text-white font-semibold">Clic aqui para proceder a coordinar la compra con un asesor</p>
                                    </button>
                                    
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- END INFO EMPRESA -->
        <!-- END INFO EMPRESA -->
        <!-- END INFO EMPRESA -->


        <!-- START PROMOCIONES -->
        <!-- START PROMOCIONES -->
        <!-- START PROMOCIONES -->
        
        <!-- END PROMOCIONES -->
        <!-- END PROMOCIONES -->
        <!-- END PROMOCIONES -->


        <!-- <div class="container mx-auto px-4 sm:px-6 lg:px-8 py-12">
            <div class="grid grid-cols-2">
                <div class="col-span-1">
                    <Splide id="main-carousel" :options="{
                        type: 'fade',
                        rewind: true,
                        pagination: false,
                        arrows: false,
                    }">
                        <SplideSlide>
                            <img src="/img/productos/independiente/01.jpg" alt="Sample 1">
                        </SplideSlide>
                        <SplideSlide>
                            <img src="/img/productos/independiente/02.jpg" alt="Sample 2">
                        </SplideSlide>
                        <SplideSlide>
                            <img src="/img/productos/independiente/03.jpg" alt="Sample 2">
                        </SplideSlide>
                    </Splide>

                    <Splide :options="{
                        fixedWidth: 100,
                        fixedHeight: 60,
                        gap: 10,
                        rewind: true,
                        pagination: false,
                        cover: true,
                        focus: 'center',
                        breakpoints: {
                            600: {
                                fixedWidth: 60,
                                fixedHeight: 44,
                            },
                        },
                    }">
                        <SplideSlide>
                            <img src="/img/productos/independiente/01.jpg" alt="Sample 1">
                        </SplideSlide>
                        <SplideSlide>
                            <img src="/img/productos/independiente/02.jpg" alt="Sample 2">
                        </SplideSlide>
                        <SplideSlide>
                            <img src="/img/productos/independiente/03.jpg" alt="Sample 2">
                        </SplideSlide>
                        <SplideSlide>
                            <img src="/img/productos/independiente/04.jpg" alt="Sample 2">
                        </SplideSlide>
                        <SplideSlide>
                            <img src="/img/productos/independiente/05.jpg" alt="Sample 2">
                        </SplideSlide>
                    </Splide>
                </div>
            </div>

        </div> -->


    </BreezeGuestLayout>
</template>

<style scoped>
.splide__slide img {

    object-fit: cover;
}
</style>
